import circle from '../assets/circle.svg'
import square from '../assets/square.svg'
import bar from '../assets/bar.svg'
import triangle from '../assets/triangle.svg'
import guess from '../assets/guess_img.png'
import roomie from '../assets/roomie.png'
import jamflix from '../assets/jamflix.png'
import search_app from '../assets/b_search.jpg'
import real_estate from '../assets/real_estate.png'
import spexbyte from '../assets/spexbyte.png'
import gameshop from '../assets/gameshop.png'

export default {
    bar,
    circle,
    square,
    triangle,
    guess,
    roomie,
    jamflix,
    search_app,
    real_estate,
    spexbyte,
    gameshop
}